import { FC } from "react";
import { format } from "date-fns";
import { CalendarIconSvg } from "@pepdirect/v3/ui/icons";
import { convertISO8601ToBrowserDate } from "@pepdirect/v3/helpers/date";
import { StyledDate, StyledRequestedDeliveryDate } from "./index.styled";

export const RequestedDeliveryDateSummary: FC<{
  requestedDeliveryDate: string;
  yourRequestedDateText: string;
}> = ({ requestedDeliveryDate, yourRequestedDateText }) => {
  return (
    <StyledRequestedDeliveryDate>
      <CalendarIconSvg />
      <span>
        {yourRequestedDateText}{" "}
        <StyledDate>
          {format(
            convertISO8601ToBrowserDate(requestedDeliveryDate),
            "EEEE, MMMM d"
          )}
        </StyledDate>
      </span>
    </StyledRequestedDeliveryDate>
  );
};
